export class WordListItem {
  constructor(public word: string, public size = 0) {}
}
